import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dimmer, Loader } from "semantic-ui-react";

/**
 * Loading component that shows full size in it's parent container.
 */
const ContentLoader = ({ content, isLoading, t }) => {
  if (!isLoading) {
    return <div />;
  }

  return (
    <Dimmer active inverted>
      <Loader inverted content={content === "Loading" ? t("loading") : content} />
    </Dimmer>
  );
};

ContentLoader.propTypes = {
  content: PropTypes.string,
  isLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

ContentLoader.defaultProps = {
  content: "Loading",
  isLoading: true,
};

export default withTranslation()(ContentLoader);
